module.exports = __webpack_public_path__ + "img/zapier.013c8642.png";